<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>海外事务管理</el-breadcrumb-item>
      <el-breadcrumb-item>海外兑换码申请记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
                clearable
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="海外赛区" prop="districtId">
              <el-select
                placeholder="请选择赛区"
                style="width: 100%"
                v-model="queryForm.districtId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in districtList"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择赛程"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
                clearable
              >
                <el-option
                  v-for="item in raceScheduleList"
                  :key="item.productId"
                  :label="item.productName"
                  :value="item.productId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="审核状态" prop="state">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.state"
                clearable
              >
                <el-option label="待审核" :value="0"></el-option>
                <el-option label="审核通过" :value="1"></el-option>
                <el-option label="驳回" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            plain
            style="width: 100%"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 申请记录列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">申请记录列表</span>
        </el-col>
        <el-col :span="15">
          <div class="div_algin_right">
            <el-button
              type="primary"
              @click="handleBatchAudit"
              :disabled="selectedRows.length === 0"
              >批量审核</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="用户信息" width="180px">
          <template slot-scope="scope">
            <div class="text-ellipsis">用户名:{{ scope.row.userName || '-' }}</div>
            <div class="text-ellipsis user-info-email">邮箱:{{ scope.row.email || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="赛程" prop="raceSchedule" :formatter="raceScheduleFormatter"></el-table-column>
        <el-table-column label="审核状态" prop="state">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 0" type="warning" size="mini">待审核</el-tag>
            <el-tag v-else-if="scope.row.state === 1" type="success" size="mini">审核通过</el-tag>
            <el-tag v-else-if="scope.row.state === 2" type="danger" size="mini">驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="解锁码">
          <template slot-scope="scope">
            {{ (scope.row.overseasMatchCode && scope.row.overseasMatchCode.code) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="赛区名称" prop="district.districtName">
          <template slot-scope="scope">
            {{ scope.row.district ? scope.row.district.districtName : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请备注" prop="applyRemark">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.applyRemark || '-'"
              placement="top"
            >
              <span class="text-ellipsis">{{ scope.row.applyRemark || '-' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleAudit(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 审核对话框 -->
    <el-dialog
      :title="auditForm.idList.length > 1 ? '批量审核' : '审核'"
      :visible.sync="auditDialogVisible"
      width="50%"
      @close="auditDialogClose"
    >
      <el-form
        :model="auditForm"
        label-width="120px"
        ref="auditFormRef"
        :rules="auditRules"
        style="width: 100%"
      >
        <el-form-item label="审核结果" prop="state">
          <el-select
            v-model="auditForm.state"
            placeholder="请选择审核结果"
            style="width: 100%"
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="通过" :value="1"></el-option>
            <el-option label="驳回" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核备注" prop="reviewRemark">
          <el-input
            type="textarea"
            v-model="auditForm.reviewRemark"
            placeholder="请输入审核备注"
            :rows="4"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOverseasApplyCodeList, auditOverseasApplyCode, queryDistrictPage } from '@/http/api'
export default {
  data () {
    return {
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        state: null,
        raceSchedule: null,
        districtId: null,
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
      total: 0,
      dict_season: [],
      districtList: [], // 海外赛区列表
      raceScheduleList: [
        {
          productId: 1,
          productName: '初选',
          productFlag: 'INDIVIDUAL_PRELIMINARY',
          productDetailId: 1
        },
        {
          productId: 2,
          productName: '区域决选',
          productFlag: 'INDIVIDUAL_FINAL',
          productDetailId: 2
        }
      ], // 赛程列表
      selectedRows: [], // 选中的行数据
      auditDialogVisible: false, // 审核对话框显示状态
      auditForm: {
        state: null, // 审核结果：0待审核、1通过、2驳回
        reviewRemark: '', // 审核备注
        senEmailType: true, // 默认true
        idList: [] // 主键id数组
      },
      auditRules: {
        state: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        reviewRemark: [{ required: true, message: '请输入审核备注', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => {
      this.dict_season = value
      this.getDataList()
    })
    // 获取海外赛区列表
    this.getDistrictList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getOverseasApplyCodeList(this.queryForm).then((res) => {
        console.log('getOverseasApplyCodeList', res)
        this.dataList = res.data.list || []
        this.total = res.data.total || 0
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取列表失败')
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 表格选择变化
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    // 判断行是否可选（只能选择状态为0待审核的）
    checkSelectable (row) {
      return row.state === 0
    },
    // 单条审核
    handleAudit (row) {
      this.auditForm.idList = [row.id]
      this.auditDialogVisible = true
    },
    // 批量审核
    handleBatchAudit () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条待审核的记录')
        return
      }
      // 过滤出状态为0的记录
      const pendingRows = this.selectedRows.filter(row => row.state === 0)
      if (pendingRows.length === 0) {
        this.$message.warning('只能选择待审核状态的记录')
        return
      }
      this.auditForm.idList = pendingRows.map(row => row.id)
      this.auditDialogVisible = true
    },
    // 提交审核
    submitAudit () {
      this.$refs.auditFormRef.validate(async valid => {
        if (!valid) return

        const params = {
          state: this.auditForm.state,
          reviewRemark: this.auditForm.reviewRemark,
          senEmailType: this.auditForm.senEmailType,
          idList: this.auditForm.idList
        }

        auditOverseasApplyCode(params).then((res) => {
          console.log('auditOverseasApplyCode', res)
          this.$message.success('审核成功')
          this.auditDialogVisible = false
          this.getDataList()
        }).catch((err) => {
          console.log('审核失败', err)
          this.$message.error('审核失败')
        })
      })
    },
    // 关闭审核对话框
    auditDialogClose () {
      this.$refs.auditFormRef.resetFields()
      this.auditForm = {
        state: null,
        reviewRemark: '',
        senEmailType: true,
        idList: []
      }
      this.selectedRows = []
    },
    // 获取海外赛区列表
    getDistrictList () {
      const params = {
        regionType: 'overseas',
        pageNum: 1,
        pageSize: 10000
      }
      queryDistrictPage(params).then((res) => {
        console.log('getDistrictList', res)
        this.districtList = res.data.list || []
      }).catch((err) => {
        console.log('获取赛区列表失败', err)
        this.$message.error('获取赛区列表失败')
      })
    },
    // 赛程格式化
    raceScheduleFormatter (row) {
      const raceSchedule = String(row.raceSchedule)
      const schedule = this.raceScheduleList.find(item => String(item.productId) === raceSchedule)
      return schedule ? schedule.productName : raceSchedule
    }
  }
}
</script>

<style lang="less" scoped>
.div_algin_right {
  text-align: right;
}
.text-ellipsis {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.user-info-email {
  color: #666;
  font-size: 12px;
}
</style>
